import { StackScreenProps } from "@react-navigation/stack";
import { StockCountFilterRootParamList } from "../../../../types";
import { StockCountFilterValues } from "../../types";
import { useListFilterContext } from "../../../../utilities/list-filter/use-list-filter-context";
import { useGenericFilterListScreenProvider } from "../../../../components/GenericFilterListScreen";
import React from "react";
import { Q } from "@nozbe/watermelondb";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import Location from "../../../../utilities/data/model/Location";
import { useTranslation } from "../../../../utilities/i18n";
import {
  Text,
  Card,
  FlatActionList,
  Page,
  Stack,
} from "@towersystems/roam-common-native";

export type StockCountFilterScreenProps = StackScreenProps<
  StockCountFilterRootParamList,
  "StockCountFilterScreen"
>;

export const StockCountFilterScreen = ({
  navigation,
}: StockCountFilterScreenProps) => {
  const { t } = useTranslation("stock_counts");

  const db = useDatabase();

  const { setScreenOptions } = useGenericFilterListScreenProvider();

  const { getFilterValues, setFilterValue, watch } =
    useListFilterContext<StockCountFilterValues>();
  const { locationId = [] } = watch();

  const handleOnLocationFilterSelect = React.useCallback(async () => {
    const locations = await db.collections
      .get<Location>("locations")
      .query(Q.and(Q.where("deleted_at", Q.eq(null))));

    setScreenOptions({
      title: t("common:action.filter_location.label"),
      options: locations.map((location) => ({
        id: location.id,
        name: location.name,
      })),
      initialSelectedOptions: getFilterValues("locationId") ?? [],
      onSelectOption: (ids) => setFilterValue("locationId", ids),
    });

    navigation.navigate("GenericFilterListScreen");
  }, []);

  return (
    <Page
      title={t("select_stockcount_filter_title")}
      secondaryTitle={t("select_stockcount_filter_subtitle")}
    >
      <Stack vertical>
        <Card>
          <FlatActionList
            items={[
              {
                key: "locationId",
                title: t("common:action.filter_location.label"),
                subTitle: t("common:action.filter_location.description"),
                onPress: handleOnLocationFilterSelect,
                isAction: (locationId.length || 0) > 0,
                componentRight: (icon) => {
                  return (locationId.length || 0) > 0 ? (
                    <Stack centerVertical>
                      <Text color="action">{locationId.length} selected</Text>
                      {icon}
                    </Stack>
                  ) : (
                    icon
                  );
                },
              },
            ]}
          />
        </Card>
      </Stack>
    </Page>
  );
};
